/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} DraftsInputs */

const en_drafts = /** @type {(inputs: DraftsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drafts`)
};

const de_drafts = /** @type {(inputs: DraftsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entwürfe`)
};

/**
* | output |
* | --- |
* | "Drafts" |
*
* @param {DraftsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const drafts = /** @type {((inputs?: DraftsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<DraftsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_drafts(inputs)
	return de_drafts(inputs)
});